import React from "react";

// Animated competitor→your-business foot-traffic signal map. Uses the global
// .srx-signal-map styles (marketing.css) which are bundled site-wide.
export default function SignalMap() {
  return (
    <div className="srx-signal-map">
      <svg viewBox="0 0 820 260" xmlns="http://www.w3.org/2000/svg" role="img"
        aria-label="A device detected at a competitor location, then confirmed as a visit at your business">
        <g stroke="#16233A" strokeWidth="1">
          <line x1="0" y1="40" x2="820" y2="40" /><line x1="0" y1="90" x2="820" y2="90" />
          <line x1="0" y1="140" x2="820" y2="140" /><line x1="0" y1="190" x2="820" y2="190" />
          <line x1="0" y1="240" x2="820" y2="240" /><line x1="120" y1="0" x2="120" y2="260" />
          <line x1="280" y1="0" x2="280" y2="260" /><line x1="440" y1="0" x2="440" y2="260" />
          <line x1="600" y1="0" x2="600" y2="260" /><line x1="760" y1="0" x2="760" y2="260" />
        </g>
        <circle cx="150" cy="150" r="70" fill="none" stroke="#6C93B4" strokeWidth="1.5" strokeDasharray="5 5" />
        <circle cx="150" cy="150" r="5" fill="#6C93B4" />
        <text x="150" y="238" textAnchor="middle" fill="#8496A8" fontFamily="JetBrains Mono, monospace" fontSize="12">COMPETITOR POI</text>
        <text x="150" y="60" textAnchor="middle" fill="#5F7488" fontFamily="JetBrains Mono, monospace" fontSize="10.5">T+0:00 DEVICE DETECTED</text>
        <circle cx="660" cy="150" r="70" fill="none" stroke="#F2A33D" strokeWidth="1.8" />
        <circle cx="660" cy="150" r="70" fill="none" stroke="#F2A33D" strokeWidth="1" opacity="0.5">
          <animate attributeName="r" values="70;92;70" dur="3s" repeatCount="indefinite" />
          <animate attributeName="opacity" values="0.5;0;0.5" dur="3s" repeatCount="indefinite" />
        </circle>
        <circle cx="660" cy="150" r="5" fill="#F2A33D" />
        <text x="660" y="238" textAnchor="middle" fill="#F2A33D" fontFamily="JetBrains Mono, monospace" fontSize="12">YOUR POI</text>
        <text x="660" y="60" textAnchor="middle" fill="#B97418" fontFamily="JetBrains Mono, monospace" fontSize="10.5">T+0:41 VISIT CONFIRMED</text>
        <path d="M150,150 C300,60 500,60 660,150" fill="none" stroke="#2A3B4E" strokeWidth="1.5" strokeDasharray="3 4" />
        <circle r="6">
          <animateMotion dur="4s" repeatCount="indefinite" path="M150,150 C300,60 500,60 660,150" />
          <animate attributeName="fill" values="#6C93B4;#6C93B4;#F2A33D;#F2A33D" keyTimes="0;0.45;0.55;1" dur="4s" repeatCount="indefinite" />
        </circle>
      </svg>
      <div className="srx-map-caption">
        <span><span className="srx-dot" style={{ background: "#6C93B4" }} />Detected at competitor</span>
        <span><span className="srx-dot" style={{ background: "#F2A33D" }} />Attributed visit at your business</span>
      </div>
    </div>
  );
}
